<template>
  <div class="setWorkerPage">
    <Form :label-width="60" class="content">
      <FormItem label="摆位">
        <Row :gutter="24">
          <span v-for="(val, index) in placementList" :key="index + 'place'">
            <Button :class="{primary:activePlace==index}" size="large" @click="setPlacements(val, index)">{{val.user_name || ''}}</Button>
          </span>
        </Row>
      </FormItem>
      <FormItem label="打针">
        <Row :gutter="24">
          <span v-for="(val, index) in injectionList" :key="index + 'inject'">
            <Button :class="{primary:activeInject==index}" size="large" @click="setInjections(val, index)">{{val.user_name || ''}}</Button>
          </span>
        </Row>
      </FormItem>
      <FormItem label="扫描">
        <Row :gutter="24">
          <span v-for="(val, index) in scanningList" :key="index + 'scan'">
            <Button disabled :class="{primary:activeScan==index}" size="large" @click="setScannings(val, index)">{{val.user_name || ''}}</Button>
          </span>
        </Row>
      </FormItem>
      <FormItem label="机器后处理">
        <Row :gutter="24">
          <span v-for="(val, index) in handlerList" :key="index + 'hand'">
            <Button :class="{primary:activeHand==index}" size="large" @click="setHandlers(val, index)">{{val.user_name || ''}}</Button>
          </span>
        </Row>
      </FormItem>
    </Form>
    <div class="footer">
      <Button v-if="checkId.isCancel" size="large" class="cancel" @click="cancel">返回</Button>
      <Button class="sure" size="large" type="primary" @click="save" :loading="saveLoading">保存</Button>
    </div>
  </div>
</template>

<script>
import { setSession, getSession, toast } from '../../libs/utils'
import { Form, Row, Button } from 'ant-design-vue'
import { getWorkerList, addSetWorker } from '../../api/check'
import { historySetWorker } from '../../api/report'
export default {
  components: {
    Form,
    FormItem: Form.Item,
    Row,
    Button
  },
  props: {
    checkId: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      placementList: [
        { user_name: '无', id: 0 }
      ],
      injectionList: [
        { user_name: '无', id: 0 }
      ],
      scanningList: [
        { user_name: '无', id: 0 }
      ],
      handlerList: [
        { user_name: '无', id: 0 }
      ],
      setWorker: [],
      activePlace: 0,
      activeInject: 0,
      activeScan: 0,
      activeHand: 0,
      curPlacement: {},
      curInjection: {},
      curScanning: {},
      curHandler: {},
      historyData: {},
      saveLoading: false
    }
  },
  methods: {
    // 选择摆位人
    setPlacements (val, index) {
      this.activePlace = index
      this.curPlacement = val
    },
    // 选择打针人
    setInjections (val, index) {
      this.activeInject = index
      this.curInjection = val
    },
    // 选择扫描人
    setScannings (val, index) {
      this.activeScan = index
      this.curScanning = val
    },
    // 选择后处理
    setHandlers (val, index) {
      this.activeHand = index
      this.curHandler = val
    },
    // 获取设置人数据
    async getWorkerData () {
      let data = await getWorkerList({ orderCheckId:  this.checkId && this.checkId.id })
      if (data) {
        this.setWorker = data
        this.placementList = this.placementList.concat(this.setWorker['positionSetterList'].operatorList ? this.setWorker['positionSetterList'].operatorList : [])
        this.injectionList = this.injectionList.concat(this.setWorker['injectionsList'].operatorList ? this.setWorker['injectionsList'].operatorList : [])
        this.scanningList = this.scanningList.concat(this.setWorker['scannerList'].operatorList ? this.setWorker['scannerList'].operatorList : [])
        this.handlerList = this.handlerList.concat(this.setWorker['inMachinePostProcessList'].operatorList ? this.setWorker['inMachinePostProcessList'].operatorList : [])
        this.defaultWorker()
        this.getSessionData()
      }
    },
    // 获取缓存数据并做回显
    async getSessionData () {
      let curScan = getSession('curScanning', 'object')
      await this.getHistoryData()
      try {
        this.setWorker['positionSetterList'].operatorList && this.setWorker['positionSetterList'].operatorList.forEach((val, index) => {
          if ((this.setWorker['positionSetterList'].operator === val.id)) {
            this.activePlace = index + 1
            throw new Error('END')
          } else if ((!this.setWorker['positionSetterList'].operator) && (this.historyData.positionSetter === val.id)) {
            this.activePlace = index + 1
            throw new Error('END')
          }
        })
      } catch (e) {
        if (e.message !== 'END') throw e
      }
      try {
        this.setWorker['injectionsList'].operatorList && this.setWorker['injectionsList'].operatorList.forEach((val, index) => {
          if (!this.setWorker['injectionsList'].flag && this.setWorker['injectionsList'].operator === val.id) {
            this.activeInject = index + 1
            throw new Error('END')
          } else if (!this.setWorker['injectionsList'].flag && (!this.setWorker['injectionsList'].operator) && (this.historyData.injections === val.id)) {
            this.activeInject = index + 1
            throw new Error('END')
          }
        })
      } catch (e) {
        if (e.message !== 'END') throw e
      }
      try {
        this.setWorker['scannerList'].operatorList && this.setWorker['scannerList'].operatorList.forEach((val, index) => {
          if ((this.setWorker['scannerList'].operator === val.id)) {
            this.activeScan = index + 1
            throw new Error('END')
          } else if ((!this.setWorker['scannerList'].operator) && (this.historyData.scanner === val.id)) {
            this.activeScan = index + 1
            throw new Error('END')
          } else if ((JSON.stringify(this.setWorker['scannerList'].operator) === 'null') && (JSON.stringify(this.historyData.scanner) === 'null') && (curScan.id === val.id)) {
            this.activeScan = index + 1
            throw new Error('END')
          }
        })
      } catch (e) {
        if (e.message !== 'END') throw e
      }
      try {
        this.setWorker['inMachinePostProcessList'].operatorList && this.setWorker['inMachinePostProcessList'].operatorList.forEach((val, index) => {
          if (!this.setWorker['inMachinePostProcessList'].flag && this.setWorker['inMachinePostProcessList'].operator === val.id) {
            this.activeHand = index + 1
            throw new Error('END')
          } else if (!this.setWorker['inMachinePostProcessList'].flag && (!this.setWorker['inMachinePostProcessList'].operator) && (this.historyData.inMachinePostProcess === val.id)) {
            this.activeHand = index + 1
            throw new Error('END')
          }
        })
      } catch (e) {
        if (e.message !== 'END') throw e
      }
    },
    // 跳过
    cancel () {
      this.$emit('closeSetWorker')
    },
    // 保存设置工作人
    async save () {
      let curScanning = getSession('curScanning', 'object')
      let params = {
        orderCheckId: this.checkId && this.checkId.id,
        positionSetterUserId: ((JSON.stringify(this.curPlacement) !== '{}') && this.curPlacement.id.toString()) || this.setWorker['positionSetterList'].operator || this.historyData.positionSetter || 0,
        injectionUserId: ((JSON.stringify(this.curInjection) !== '{}') && this.curInjection.id.toString()) || this.setWorker['injectionsList'].operator || this.historyData.injections || 0,
        scannerUserId: ((JSON.stringify(this.curScanning) !== '{}') && this.curScanning.id.toString()) || this.setWorker['scannerList'].operator || this.historyData.scanner || 0,
        inMachineAfterUserId: ((JSON.stringify(this.curHandler) !== '{}') && this.curHandler.id.toString()) || this.setWorker['inMachinePostProcessList'].operator || this.historyData.inMachinePostProcess || 0
      }
      if ((JSON.stringify(this.setWorker['scannerList'].operator) === 'null') && (JSON.stringify(this.historyData.scanner) === 'null')) {
        params.scannerUserId = curScanning.id
      }
      if (this.saveLoading) return false
      this.saveLoading = true
      let data = await addSetWorker(params)
      if (data) {
        this.saveLoading = false
        toast({ msg: '设置工作人成功！', type: 'success', title: '成功提示' })
        this.cancel()
      }
    },
    // 根据用户角色，默认工作人
    defaultWorker () {
      let role = getSession('userAuth', 'object').roles || []
      let user = getSession('risUserInfo', 'object') || ''
      role.forEach(val => {
        if (val.rcode === 'ROLE_TECHNICIAN') {
          setSession('curScanning', { id: user.id })
        }
      })
    },
    // 获取工作人历史数据
    async getHistoryData () {
      let data = await historySetWorker()
      if (data) {
        this.historyData = data
      }
    }
  },
  async mounted () {
    await this.getWorkerData()
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.setWorkerPage{
  .content{
    overflow-y: auto;
    overflow-x: hidden;
    height: 400px;
    .ant-form-item {
      display: flex;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
    .ant-form-item-label{
      text-align: none;
      width: 80px;
    }
  }
  .primary{
    background-color: @primaryColor;
    color: #fff;
  }
  background-color: #fff;
  span{
    button{
      margin: 0 0 @LeaveDistance @LeaveDistance;
      min-width: 100px;
      height: 56px;
    }
  }
  .footer{
    text-align: right;
    padding-top: @LeaveDistance;
    border-top: 1px solid @pageBgColor;
    .sure{
      width: @auxiliaryBtnWidth;
      height: @auxiliaryBtnHeight;
      margin-left: @LeaveDistance;
    }
    .cancel{
      width: @auxiliaryBtnWidth;
      height: @auxiliaryBtnHeight;
    }
  }
}
</style>